{
  "version": 1,
  "asset_id": "3d63ebe6-ac69-4f40-bb61-e5ac0b6c2999",
  "project_id": "6ffb2ed6-aa93-4c00-8eaf-179cce7a3ceb",
  "url": "/__l5e/assets-v1/3d63ebe6-ac69-4f40-bb61-e5ac0b6c2999/flow-haircut-1-2.webp",
  "r2_key": "a/v1/6ffb2ed6-aa93-4c00-8eaf-179cce7a3ceb/3d63ebe6-ac69-4f40-bb61-e5ac0b6c2999/flow-haircut-1-2.webp",
  "original_filename": "flow-haircut-1-2.webp",
  "size": 85338,
  "content_type": "image/webp",
  "created_at": "2026-09-09T09:54:26Z"
}
